import appInsights from '../services/applicationInsight';

export function logServerError(errorText: string, url?: string, res?: Response): void {
	if (process.env.NODE_ENV === 'production') {
		appInsights.trackException(
			{
				exception: new Error(errorText, { cause: errorText }),
			},
			{ url, type: res ? 'API error' : 'Client error', status: res?.status },
		);
	}
	console.error(errorText, url, res ? res.status : '');
}

export function logServerWarn(warningText: string, url?: string, res?: Response): void {
	if (process.env.NODE_ENV === 'production') {
		appInsights.trackTrace(
			{ message: warningText, severityLevel: 2 },
			{ url, type: res ? 'API warning' : 'Client warning', status: res?.status },
		);
	}
	console.warn(warningText, url, res ? res.status : '');
}
